import PropTypes from 'prop-types';

export const AdjustmentPropTypes = PropTypes.shape({
  account: PropTypes.string.isRequired,
  adjustmentType: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  amountFrom: PropTypes.string,
  annualCum: PropTypes.string,
  bookToTaxDescription: PropTypes.string,
  countryTaxType: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  frequency: PropTypes.string.isRequired,
  multiplier: PropTypes.number,
});
